var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "container mx-auto" };
const _hoisted_2 = { class: "p-20 mt-12 h-754px mx-auto border-2 border-orange border-solid bg-archiv bg-no-repeat bg-right-top" };
const _hoisted_3 = /*#__PURE__*/ _createStaticVNode("<footer class=\"container mx-auto mt-1\"><div class=\"p-0 w-11/12 mx-auto text-white text-center\"><a href=\"https://www.ufs-tools.com/datenschutzerklaerung.html\" class=\"text-white\" target=\"_blank\">Datenschutzerklärung</a>    |   <a href=\"https://www.ufs-tools.com/impressum.html\" class=\"text-white\" target=\"_blank\">Impressum</a>    |   <a href=\"https://www.ufs-tools.com/downloads/Handbuch.pdf\" class=\"text-white\" target=\"_blank\" title=\"Handbuch als PDF laden\">Handbuch</a></div></footer>", 1);
const _hoisted_4 = /*#__PURE__*/ _createElementVNode("h3", { class: "text-xl font-semibold text-gray-900" }, " Neues Projekt anlegen ", -1);
const _hoisted_5 = /*#__PURE__*/ _createElementVNode("svg", {
    "aria-hidden": "true",
    class: "w-5 h-5",
    fill: "currentColor",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
}, [
    /*#__PURE__*/ _createElementVNode("path", {
        "fill-rule": "evenodd",
        d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
        "clip-rule": "evenodd"
    })
], -1);
const _hoisted_6 = /*#__PURE__*/ _createElementVNode("span", { class: "sr-only" }, "Schliessen", -1);
const _hoisted_7 = [
    _hoisted_5,
    _hoisted_6
];
const _hoisted_8 = /*#__PURE__*/ _createElementVNode("button", {
    type: "submit",
    class: "mb-2 w-1/2 px-6 py-2.5 bg-orange text-white text-xs leading-normal uppercase"
}, "Projekt anlegen ", -1);
import axios from "axios";
import { ref, computed, onMounted } from 'vue';
import ModalComponent from './components/ModalComponent.vue';
import ProjectsComponent from './components/ProjectsComponent.vue';
import VueSimpleAlert from "vue3-simple-alert";
export const componentName = 'App';
const __default__ = {
    name: componentName,
    inheritAttrs: false,
};
export default /*#__PURE__*/ _defineComponent(Object.assign(Object.assign({}, __default__), { setup(__props) {
        const baseUrl = '/api/';
        const endpoint = ref('projects');
        const url = computed(() => baseUrl + endpoint.value);
        let showModal = ref(false);
        let projects = ref([]);
        const fetchData = () => __awaiter(this, void 0, void 0, function* () {
            const res = yield fetch(url.value);
            projects.value = yield res.json();
        });
        const validateASCII = (string) => {
            let regex = /^[\x00-\x7F]+$/;
            return regex.test(string);
        };
        const confirmOptions = {
            confirmButtonColor: '#b3b3b3',
            cancelButtonColor: '#ff7849',
            confirmButtonText: 'JA',
            cancelButtonText: 'NEIN',
        };
        const alertOptions = {
            confirmButtonColor: '#b3b3b3'
        };
        const submitForm = (name) => __awaiter(this, void 0, void 0, function* () {
            try {
                if (validateASCII(name)) {
                    const response = yield axios.post('/api/project-name', { name: name });
                    if (response.status === 200) {
                        yield fetchData();
                    }
                }
                else {
                    console.log("Unerlaubte Zeichen im Projektnamen");
                }
                toggleModal();
            }
            catch (error) {
                console.error(error);
            }
        });
        const removeProject = (name) => {
            VueSimpleAlert.confirm("Soll das gesamte Projekt \"" + name + "\" gelöscht werden ?", "", "warning", confirmOptions).then(() => {
                deleteProject(name);
            });
        };
        const deleteProject = (name) => __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield axios.post('/api/remove-project', { name: name });
                if (response.status === 200) {
                    yield fetchData();
                }
            }
            catch (error) {
                VueSimpleAlert.alert("Beim Löschen ist ein Fehler aufgetreten?", "", "error", alertOptions).then(() => {
                    console.error(error);
                });
            }
        });
        const toggleModal = () => {
            showModal.value = !showModal.value;
        };
        onMounted(() => __awaiter(this, void 0, void 0, function* () {
            yield fetchData();
        }));
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("button", {
                        class: "mb-2 px-6 py-3 text-white no-underline bg-orange rounded",
                        onClick: toggleModal
                    }, "Neues Projekt anlegen"),
                    _createVNode(ProjectsComponent, {
                        onOnRemoveProject: removeProject,
                        projects: _unref(projects)
                    }, null, 8, ["projects"])
                ]),
                _hoisted_3,
                (_unref(showModal))
                    ? (_openBlock(), _createBlock(ModalComponent, {
                        key: 0,
                        onClose: toggleModal,
                        onOnSubmitForm: submitForm
                    }, {
                        header: _withCtx(() => [
                            _createElementVNode("div", { class: "flex items-start justify-between p-4 border-b roundedt dark:border-gray-600" }, [
                                _hoisted_4,
                                _createElementVNode("button", {
                                    type: "button",
                                    onClick: toggleModal,
                                    class: "text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-gray-600 dark:hover:text-white"
                                }, _hoisted_7)
                            ])
                        ]),
                        footer: _withCtx(() => [
                            _createElementVNode("div", { class: "flex items-center p-6 space-x-2 border-t border-gray-200 rounded-b dark:border-gray-600" }, [
                                _hoisted_8,
                                _createElementVNode("button", {
                                    type: "button",
                                    onClick: toggleModal,
                                    class: "mb-2 w-1/2 px-6 py-2.5 bg-orange text-white text-xs leading-normal uppercase"
                                }, "Abbrechen ")
                            ])
                        ]),
                        _: 1
                    }))
                    : _createCommentVNode("", true)
            ]));
        };
    } }));
